import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from '../../security/authentication/authentication.service';
import { HttpClient } from '@angular/common/http';
import { User } from '../../security/authentication/user';
import { PasswordChangeDTO } from '../password-change-dto.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-password-change-dialog',
  templateUrl: './password-change-dialog.component.html',
  styleUrls: ['./password-change-dialog.component.scss']
})
export class PasswordChangeDialogComponent {
  data: { oldPassword: string; newPassword1: string; newPassword2: string };
  loggedUser: User;
  invalidPassword: boolean;

  constructor(
    public dialogRef: MatDialogRef<PasswordChangeDialogComponent>,
    public authService: AuthenticationService,
    private http: HttpClient
  ) {
    this.data = { oldPassword: '', newPassword1: '', newPassword2: '' };
    this.authService.currentUser.subscribe((user: User) => (this.loggedUser = user));
    this.invalidPassword = false;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.http
      .put(
        environment.gatewayEndpoints.auth + '/user/password-change',
        new PasswordChangeDTO({
          username: this.loggedUser.username,
          currentPassword: this.data.oldPassword,
          newPassword1: this.data.newPassword1,
          newPassword2: this.data.newPassword2
        })
      )
      .subscribe(
        response => {
          this.dialogRef.close();
        },
        error => {
          console.error('Error en el intento de cambio de contraseña: ', error.error.description);
          // TODO: Utilizar sistema por códigos
          if (error.error.description.includes('Incorrect password.')) {
            this.invalidPassword = true;
          }
        }
      );
  }
}
